import React from 'react'

import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@/components/ui/hover-card'
import { useAdminUsers } from '@/hooks/useAdminUsers'
import { cn } from '@/lib/utils'

type Props = React.ComponentProps<'span'>

export const AdminUsersHoverCard: React.FC<Props> = ({
  className,
  children,
  ...props
}) => {
  const adminUsers = useAdminUsers()

  function renderTrigger() {
    return (
      <span {...props} className={cn('underline', className)}>
        {children}
      </span>
    )
  }

  // A company should have at least 1 company admin so if there is 0, it should
  // only be because we're still loading the admins
  if (adminUsers.length === 0) {
    renderTrigger()
  }

  return (
    <HoverCard>
      <HoverCardTrigger asChild>{renderTrigger()}</HoverCardTrigger>
      <HoverCardContent align="start">
        <p className="mb-2">Your company's admins are:</p>

        <ul>
          {adminUsers.map((admin) => (
            <li key={admin.id}>{admin.user.fullName}</li>
          ))}
        </ul>
      </HoverCardContent>
    </HoverCard>
  )
}
